import tomato from '@/assets/tomato2.png';
import olive from '@/assets/olive.png';
export default function AboutSection() {
  return (
    <section id="about" className="py-24 md:py-32 reveal overflow-visible">
      <div className="max-w-4xl mx-auto px-4 md:px-6 relative">
        {/* トマト：左上あたり */}
        <img
          src={tomato}
          alt=""
          aria-hidden="true"
          className="absolute left-0 md:-left-8 top-16 md:top-24 w-20 md:w-40 pointer-events-none select-none hidden md:block"
        />
        {/* オリーブ：右下あたり */}
        <img
          src={olive}
          alt=""
          aria-hidden="true"
          className="absolute right-0 md:-right-6 bottom-20 md:bottom-28 w-20 md:w-40 rotate-11 pointer-events-none select-none hidden md:block"
        />
        <div className="gap-2 text-primary-400 font-script text-5xl text-center">
          &mdash; Concept &mdash;
        </div>

        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.35] mb-8 text-center">
          炎と食材が<br />
          語り合う場所
        </h2>

        <p className="text-foreground-300 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-12">
          Trattoria Soleは「太陽の食堂」という名の通り、<br className="hidden md:block" />
          陽だまりのような温もりに包まれたイタリアンレストランです。<br />
          薪窯の炎が躍るオープンキッチンからは、<br className="hidden md:block" />
          食材の香りとシェフの情熱がダイレクトに伝わります。<br /><br />
          産地直送の旬の食材を、シンプルかつ丁寧に。<br />
          薪窯で焼き上げるピッツァ、手打ちの生パスタ、<br className="hidden md:block" />
          そしてソムリエが厳選したイタリアワイン。<br />
          すべてが揃ったとき、最高の食体験が生まれます。
        </p>

        <div className="text-center gap-2 text-primary-400/50 font-script text-2xl">
          Buon appetito
        </div>
      </div>
    </section>
  );
}